<!--
*@Description: 左侧导航栏组件
*@Author: wanggang
*@Date: 2020-05-11 17:29:29
-->
<template>
	<fragment>
		<template v-for="(item_1,index_1) in menuData">
			<!-- 一级菜单 -->
			<el-menu-item v-if="item_1.showMenu && !item_1.children"
				:key="index_1" :index="item_1.path+''" 
				:class="$route.path===item_1.path?'is-active':''">
				<i :class="item_1.meta.icon"></i>
				<span slot="title">{{item_1.name}}</span>
			</el-menu-item>
			
			<el-submenu v-if="item_1.showMenu && item_1.children" 
				:key="index_1" :index="item_1.path+''" >
				<!-- 一级菜单标题 -->
				<template slot="title">
					<i :class="item_1.meta.icon"></i>
					<span slot="title">{{item_1.name}}</span>
				</template>
				
				<template v-for="(item_2,index_2) in item_1.children">				
					<!-- 二级菜单没有子路由的时候 -->
					<!-- {{term}} -->
					<el-menu-item v-if="item_2.showMenu && !item_2.children" 
						:key="item_2.path+''+ item_2.name" :index="item_2.path+''"
						:class="$route.path===item_2.path?'is-active':''">
						<i :class="item_2.meta.icon"></i>
						<span slot="title">{{item_2.name}}</span>
					</el-menu-item>
					<!-- 二级菜单有子路由的时候,递归循环自身 -->
					<!-- <template v-if="item_2.showMenu && item_2.children">
						<template v-for="item_3 in item_2">
							<MenuNav :key="index_2" :menuData="item_3"></MenuNav>
						</template>						
					</template> -->
					
				</template>
			</el-submenu>

			
		</template>
	</fragment>
</template>

<script>
	export default {
		name: 'MenuNav',
		props: ['menuData'],
		components: {},
		data() {
			return {};
		},
		computed: {},
		watch: {},
		created() {
			// console.log('MenuNav created()');
			// // console.log(Array.isArray(this.menuData));
			// console.log('this.menuData');
			// console.log(this.menuData);
			// console.log('this.menuData[0]');
			// console.log(this.menuData[0]);
			// console.log('this.menuData[0].children');
			// console.log((this.menuData[0]).children);

			// console.log('this.menuData[1]');
			// console.log(this.menuData[1]);
			// console.log('this.menuData[1].children');
			// console.log((this.menuData[1]).children);
		},
		mounted() {
			// console.log('MenuNav mounted()');
			// console.log(Array.isArray(this.menuData));
			// console.log('this.menuData');
			// console.log(this.menuData);
			// console.log('this.menuData[0]');
			// console.log(this.menuData[0]);
			// console.log('this.menuData[0].children');
			// console.log((this.menuData[0]).children);

			// console.log('this.menuData[1]');
			// console.log(this.menuData[1]);
			// console.log('this.menuData[1].children');
			// console.log((this.menuData[1]).children);
		},
		destroyed() {},
		methods: {},
	};
</script>

<style>

</style>
